// Byråns utskicksläge: när en färdig offert skickas (ADR 0031 och 0045).
// Fördröjt utskick väntar minuter eller till nästa arbetsdag kl. 08.
import { z } from 'zod';

export const dispatchSchema = z.discriminatedUnion('mode', [
  z.object({ mode: z.literal('direct') }),
  z.object({
    mode: z.literal('delayed'),
    delay: z.discriminatedUnion('type', [
      z.object({ type: z.literal('minutes'), minutes: z.int().min(1).max(1440) }),
      z.object({ type: z.literal('nextWorkday') }),
    ]),
  }),
  z.object({ mode: z.literal('approve_first') }),
]);

export type Dispatch = z.infer<typeof dispatchSchema>;
